export default "__VITE_ASSET__$tnIcCcy__"